import { computed, reactive, readonly } from 'vue';

function createReadyMap(state) {
  const readyMap = {};
  Object.keys(state).forEach((key) => {
    readyMap[key] = false;
  });
  return readyMap;
}

export default function createStore(store) {
  const { state = {}, actions = {}, update } = store;
  const proto = {};
  const storeProxy = {};
  const refState = reactive(state);
  const ready = createReadyMap(state);

  function init(key) {
    if (!ready[key]) {
      ready[key] = true;
      // eslint-disable-next-line no-use-before-define
      update[key]({ commit, action });
    }
  }

  Object.keys(state).forEach((key) => {
    storeProxy[key] = readonly(
      computed(() => {
        // 是否需要第一次触发懒加载
        if (Object.prototype.hasOwnProperty.call(update, key)) {
          init(key);
        }

        return refState[key];
      }),
    );
  });
  Object.setPrototypeOf(storeProxy, proto);

  function commit(key, value) {
    if (Object.prototype.hasOwnProperty.call(state, key)) {
      refState[key] = value;
    } else {
      console.error(`commit错误(store中没有这样的属性):${key}`);
    }
  }

  async function action(key, ...args) {
    if (Object.prototype.hasOwnProperty.call(actions, key)) {
      const result = await actions[key](storeProxy, ...args);
      return result;
    }
    return Promise.reject(new Error(`action错误(store中没有这样的action:${key}`));
  }

  function reload(key) {
    if (
      Object.prototype.hasOwnProperty.call(state, key)
      && Object.prototype.hasOwnProperty.call(update, key)
    ) {
      return update[key]({ commit, action });
    }
    return new Error(`clear错误(store中没有这样的:${key})`);
  }

  proto.commit = commit;
  proto.action = action;
  proto.reload = reload;

  Object.freeze(storeProxy);
  return storeProxy;
}
